import { render } from "./dealer_buffer_stock.vue?vue&type=template&id=7a8fbbb1&scoped=true"
import script from "./dealer_buffer_stock.vue?vue&type=script&lang=js"
export * from "./dealer_buffer_stock.vue?vue&type=script&lang=js"

import "./dealer_buffer_stock.vue?vue&type=style&index=0&id=7a8fbbb1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8fbbb1"]])

export default __exports__